module.exports = __webpack_public_path__ + "static/media/JC.56c4541c.svg";